import React, { useEffect, useRef, useLayoutEffect, useState } from 'react';
import AppFooter from 'Layout/AppFooter';
import AppHeader from 'Layout/AppHeader';
import AppSidebar from 'Layout/AppSidebar';
import ThemeOptions from 'Layout/ThemeOptions';
import { ProSidebarProvider } from 'react-pro-sidebar';
import AppMain from '.';
import { ToastContainer } from 'react-toastify';
import Auth from "services/Auth";
import { Button, Modal, ModalBody } from 'reactstrap';
import { useLocation, useNavigate } from "react-router-dom";
import { useThemeSettings} from 'Api/Admin/Theme';
import {
    mapBackendThemeSettings,
    applyThemeToRoot,getCachedThemeSettings,setCachedThemeSettings
} from '../../helperFunctions/UiTheme'

const Layout = () => {
    const [showDisableModal, setShowDisableModal] = useState(false);
    const isLoggedIn = Auth.isLoggedIn();
    const location = useLocation();

    const navigate = useNavigate();

    const currentPathRef = useRef(location.pathname);
    const previousPathRef = useRef(null);


    const noPageFoundPaths = ["/no-page-found", "/no-access", "/*", "/do-not-have-permmison", '/login'];
    const isNoPageFound = noPageFoundPaths.includes(location.pathname);
    const hideAppFooter = location.pathname.startsWith('/afas');

    const {
        data: themeSettingsData,
        isLoading: isThemeLoading,
    } = useThemeSettings();
    
    useLayoutEffect(() => {
        const cached = getCachedThemeSettings();

        if (cached) {
            applyThemeToRoot(cached);
        }
    }, []);

    useEffect(() => {
        const handleRoleCheck = () => {
            setShowDisableModal(true);
        };

        window.addEventListener("role-check-error", handleRoleCheck);

        return () => {
            window.removeEventListener("role-check-error", handleRoleCheck);
        };
    }, []);

    useEffect(() => {
        previousPathRef.current = currentPathRef.current;
        currentPathRef.current = location.pathname;
    }, [location.pathname]);

    useEffect(() => {
        if (isThemeLoading) {
            return;
        }

        const apiData = themeSettingsData?.data || themeSettingsData || [];
        const settings = mapBackendThemeSettings(apiData);

        applyThemeToRoot(settings);
        setCachedThemeSettings(settings);
    }, [themeSettingsData, isThemeLoading]);


    if (!isLoggedIn || isNoPageFound) {
        
        return <AppMain />;
    }
   
    return (
        <>
            <Modal
                isOpen={showDisableModal}
                toggle={() => setShowDisableModal(false)}
                className="feedback-modal-style role-modal modal-centered"
            >
                <ModalBody>
                    <p className="mt-5 text-center text-red">
                        Toegang geweigerd. U hebt geen toestemming om deze pagina te bekijken. Neem contact op met de ondersteuning als u toegang nodig hebt.
                    </p>

                    <div className="d-flex align-items-center justify-content-center border-bottom-0 gap-4 py-4">
                        <Button
                            className="btn-color-style opslaan-btn px-4"
                            size="lg"
                            outline
                            color="primary"
                            onClick={() => {
                                setShowDisableModal(false);

                                if (previousPathRef.current) {
                                    navigate(previousPathRef.current);
                                } else {
                                    navigate(-1);
                                }
                            }}
                        >
                            OK
                        </Button>
                    </div>
                </ModalBody>
            </Modal>
            <ProSidebarProvider>
                <AppHeader />
                <ThemeOptions />
                <div className="app-main">
                    <AppSidebar />
                    <div className="app-main__outer">
                        <div className="app-main__inner">
                            <AppMain />
                        </div>
                    </div>
                </div>
                {/* {!hideAppFooter && <AppFooter />} */}
                <ToastContainer style={{ top: "70px" }} />
            </ProSidebarProvider>
        </>
    );
};

export default Layout;
